export default __webpack_public_path__ + "static/media/arrow-down-left.71e14e95.svg";